<template>
  <tr>
    <th>{{ date }}</th>
    <th
      class="text-center"
      :style="avaStyle"
      :title="avaDesc" >{{ avaLabel }}</th>
    <th>
      <span class="pointer"
        :style="'text-decoration:' + (hasDiscount ? 'line-through' : '')"
        @click="$emit('showPriceDetails', depDate)"
      >
        <small><translate>from</translate></small>
        {{ fullPrice.toFixed(2) }} {{ currency }}
      </span>
    </th>
    <th class="text-danger">
      <template v-if="hasPrice && hasDiscount">
        <span @click="$emit('showPriceDetails', depDate)" class="pointer">
          <small><translate>from</translate></small>
          {{ price.toFixed(2) }} {{ currency }}
        </span>
      </template>
    </th>
    <td class="text-right">
      <b-button variant="warning" size="sm" @click="$emit('selectDate', depDate)" v-if="isBookable"><span v-translate>Select</span></b-button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import availability from '@/app/private/shared/availability'

export default {
  props: {
    depDate: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  computed: {
    date () {
      return moment(this.depDate.date).format('DD-MM-YYYY')
    },
    availability () {
      return availability.find(el => el.name === this.depDate.availability)
    },
    avaLabel () {
      return this.availability.shortLabel
    },
    avaDesc () {
      return this.availability.label
    },
    avaStyle () {
      return { color: this.availability.colour }
    },
    price () {
      return this.depDate.price.gross + this.depDate.price.tax
    },
    fullPrice () {
      return this.depDate.price.gross + this.depDate.price.tax + this.depDate.price.discount
    },
    hasDiscount () {
      return !!this.depDate.price.discount
    },
    hasPrice () {
      return !!this.price
    },
    isBookable () {
      return this.availability.name !== 'unavailable'
    }
  }
}
</script>
